module.exports = __webpack_public_path__ + "static/media/filter.03754640.svg";